import Cookies from 'js-cookie';
import type {VerifyAuthRequest} from "../services/auth";
import {verifyAuth} from "../services/auth";

export const refreshTokenCookieName = 'refreshToken';
export const accessTokenCookieName = 'accessToken';

export const setRefreshToken = (refreshToken: string): void => {
    Cookies.set(refreshTokenCookieName, refreshToken, {expires: 30}); // 30-day expiry
};

export const setAccessToken = (accessToken: string): void => {
    Cookies.set(accessTokenCookieName, accessToken, {expires: 365}); // do not expire the access token
};

export const getRefreshToken = (): string | null => {
    return Cookies.get(refreshTokenCookieName) || null;
};

export const getAccessToken = (): string | null => {
    return Cookies.get(accessTokenCookieName) || null;
};

export const deleteAccessAndRefreshToken = () => {
    Cookies.remove(accessTokenCookieName, { path: '/' })
    Cookies.remove(refreshTokenCookieName, { path: '/' })
};

export const authenticationCheck = async () => {
    let accessToken = getAccessToken();
    let isAuthenticated = false;
    if (accessToken) {
        const verifyAuthRequest: VerifyAuthRequest = {
            token: accessToken
        }
        try {
            const authVerifyResponse = await verifyAuth(verifyAuthRequest);
            if (authVerifyResponse.status === 200) {
                isAuthenticated = true;
            }
        } catch (error) {
            isAuthenticated = false;
        }
    }
    return isAuthenticated;
}